import { produce } from "immer";
import * as Actions from "pages/Mail/ReadMessage/store/singleMessageActions";

import deepmerge from "deepmerge";
import combineMerge from "config/combineMerge";
import * as reminderActions from "pages/Mail/Messages/store/reminderActions";
import { applyReminderFields } from "pages/Mail/helpers/reminders";

const initialState = { byId: {}, allIds: [] };

const singleMessageReducer = produce((draft, action) => {
  switch (action.type) {
    case Actions.FETCH_SINGLE_MESSAGE_SUCCESS: {
      const payload = action.payload;
      const singleMessage = payload.singleMessage;
      const singleMessageId = singleMessage.id;

      const allIds = [singleMessageId];
      const byId = {
        [singleMessageId]: {
          ...singleMessage,
          isDownloadingAttachments: false,
          attachmentDownloadError: null
        }
      };

      const merged = deepmerge(draft.byId, byId, {
        arrayMerge: combineMerge
      });
      applyReminderFields(merged[singleMessageId], singleMessage);
      draft.byId = merged;

      draft.allIds = deepmerge(draft.allIds, allIds, {
        arrayMerge: combineMerge
      });

      break;
    }

    case reminderActions.SET_MESSAGE_REMINDERS: {
      const { id, ...fields } = action.payload;
      applyReminderFields(draft.byId[id], fields);
      break;
    }

    case Actions.DOWNLOAD_ALL_ATTACHMENTS: {
      const { id } = action.payload;
      if (draft.byId[id]) {
        draft.byId[id].isDownloadingAttachments = true;
        draft.byId[id].attachmentDownloadError = null;
      }
      break;
    }

    case Actions.DOWNLOAD_ALL_ATTACHMENTS_SUCCESS: {
      const { id } = action.payload;
      if (draft.byId[id]) {
        draft.byId[id].isDownloadingAttachments = false;
        draft.byId[id].attachmentDownloadError = null;
      }
      break;
    }

    case Actions.DOWNLOAD_ALL_ATTACHMENTS_FAILED: {
      const { id, errorMessage } = action.payload;
      if (draft.byId[id]) {
        draft.byId[id].isDownloadingAttachments = false;
        draft.byId[id].attachmentDownloadError = errorMessage;
      }
      break;
    }

    default:
      return draft;
  }
}, initialState);

export default singleMessageReducer;
